module.exports = __webpack_public_path__ + "img/progress_bg.e1366efd.png";